import { Link, useLocation } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import '../styles/header.css';

export default function Header() {
    const [isScrolled, setIsScrolled] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const location = useLocation();

    useEffect(() => {

        const handleScroll = () => {
            if (window.scrollY > 0) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
            
        }

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);


    return(
        <>
        <div id="header" style={{
            backgroundColor: isScrolled ? '#222076' : 'transparent', transition: 'background-color 0.3s ease'
        }}>
            <Link to="/"><img id="logo" src="/img/logos/logo-white.png" alt="A blue and white logo of CLV LLP"></img></Link>

            {/* Hamburger icon */}
            <div className={`hamburger ${isMenuOpen ? 'open' : ''}`} onClick={() => setIsMenuOpen(!isMenuOpen)}>
                    <span id="h1"></span>
                    <span id="h2"></span>
                    <span id="h3"></span>
                </div>

            <div id="nav" className={isMenuOpen ? 'open' : ''}>
                <ul>
                    <li><Link style={{color: isScrolled ?  '#FFF' : '#FFF', fontWeight: location.pathname === '/' ? 'bold' : '400'}} to="/">Home</Link></li>
                    <li><Link style={{color: isScrolled ?  '#FFF' : '#FFF', fontWeight: location.pathname === '/about' ? 'bold' : '400'}} to="/about">Our History</Link></li>
                    <li><Link style={{color: isScrolled ?  '#FFF' : '#FFF'}} to="/fields-of-expertise">Fields of Expertise</Link></li>
                    <li><Link style={{color: isScrolled ?  '#FFF' : '#FFF'}} to="/our-team">Our Team</Link></li>
                    <li><Link style={{color: isScrolled ?  '#FFF' : '#FFF'}} to="/contact-us">Contact Us</Link></li>
                </ul>
            </div>
        </div>
        </>
    );
}